/**
 * Utility for saving and restoring the user's location after auth redirects.
 * Uses both sessionStorage and localStorage for Safari ITP compatibility.
 */

const REDIRECT_KEY = 'auth_redirect_after_login';

/**
 * Save the current path so the user can be returned after login/register.
 * Call this before redirecting to an auth page.
 */
export const saveRedirectPath = (path?: string) => {
  const p = path || window.location.pathname + window.location.search;
  // Don't save auth pages or home
  if (
    p.includes('/client-auth') ||
    p.includes('/practitioner-auth') ||
    p.includes('/reset-password') ||
    p.includes('/forgot-password') ||
    p === '/'
  ) {
    return;
  }
  try {
    sessionStorage.setItem(REDIRECT_KEY, p);
    localStorage.setItem(REDIRECT_KEY, p);
  } catch {
    // storage full or blocked
  }
};

/**
 * Retrieve and clear the saved redirect path.
 * Checks sessionStorage first, falls back to localStorage (Safari ITP).
 */
export const getAndClearRedirectPath = (): string | null => {
  let path: string | null = null;
  try {
    path = sessionStorage.getItem(REDIRECT_KEY) || localStorage.getItem(REDIRECT_KEY);
    sessionStorage.removeItem(REDIRECT_KEY);
    localStorage.removeItem(REDIRECT_KEY);
  } catch {
    // ignore
  }
  return path;
};
